import React from 'react';
import "./Who_can_use.css"
import Common_title from '../../common/common-title/Common_title';

const Who_can_use = () => {
    return (
        <section className='Who_can_use margin_section'>
            <div className="container">
                <Common_title
                    title={"CAMPUS DEAL "}
                    subtitle={"Who Can Use It?"}
                />
                <div className="content_holder">
                    <div className="row align-items-center ">
                        <div className="col-md-6 col-sm-6 ">
                            <div className="image-collage-wrapper">
                                <div className='img_holder img_holder_1'>
                                    <img
                                        src="/assets/images/home/who-can-use/img_2.png"
                                        alt="img 1"
                                        className="collage-image-top "
                                    />
                                </div>
                                <div className='img_holder img_holder_2'>
                                    <img
                                        src="/assets/images/home/who-can-use/img_1.png"
                                        alt="img 2"
                                        className="collage-image-bottom"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-6 ">
                            <div className="timeline-list">
                                <div className="timeline-item">
                                    <div className="timeline-number-wrapper">
                                        <div className="timeline-number">01</div>
                                        <div className="timeline-line"></div>
                                    </div>
                                    <div className="timeline-content">
                                        <h4 className="timeline-title">CUSTOMER</h4>
                                        <p className="timeline-description">Find services, view expert profiles, and post your needs in minutes.</p>
                                    </div>
                                </div>
                                <div className="timeline-item">
                                    <div className="timeline-number-wrapper">
                                        <div className="timeline-number">02</div>
                                        <div className="timeline-line"></div>
                                    </div>
                                    <div className="timeline-content">
                                        <h4 className="timeline-title">VENDORS</h4>
                                        <p className="timeline-description">List your shop, get customer leads, and manage inquiries easily.</p>
                                    </div>
                                </div>
                                <div className="timeline-item">
                                    <div className="timeline-number-wrapper">
                                        <div className="timeline-number">03</div>
                                    </div>
                                    <div className="timeline-content">
                                        <h4 className="timeline-title">EXPERTS</h4>
                                        <p className="timeline-description">Showcase your skills, consult clients, and grow your visibility.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Who_can_use;